"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DivNote = DivNote;
exports.ProductForm = ProductForm;
var react_1 = __importStar(require("react"));
var api_1 = require("../api");
var react_toastify_1 = require("react-toastify");
function DivNote() {
    return (react_1.default.createElement("div", { className: "div-nite" },
        "\u2191",
        react_1.default.createElement("br", null),
        react_1.default.createElement("span", { style: { writingMode: "vertical-rl" } }, "\u4E0A\u4E0B\u6ED1\u52A8"),
        react_1.default.createElement("br", null),
        "\u2193"));
}
function ProductForm() {
    var _this = this;
    var _a = (0, react_1.useState)([]), products = _a[0], setProducts = _a[1];
    var _b = (0, react_1.useState)({
        product_id: "",
        productname: "",
    }), productProps = _b[0], setProductProps = _b[1];
    var prevProductRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (!prevProductRef.current) {
            loadProducts();
            prevProductRef.current = true;
        }
    }, []);
    var loadProducts = function () { return __awaiter(_this, void 0, void 0, function () {
        var resObj, arr, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, api_1.getProducts)()];
                case 1:
                    resObj = (_a.sent());
                    arr = Object.entries(resObj).map(function (_a) {
                        var product_id = _a[0], productname = _a[1];
                        return ({
                            product_id: product_id,
                            productname: productname,
                        });
                    });
                    setProducts(arr);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error loading products:", error_1);
                    react_toastify_1.toast.error("加载检测项目失败", api_1.toastOptions);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "form-container" },
        react_1.default.createElement("div", { className: "div-form" },
            react_1.default.createElement("form", { className: "zmsk-form hospital-form" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("table", null,
                        react_1.default.createElement("colgroup", null,
                            react_1.default.createElement("col", { style: { width: "20%" } }),
                            react_1.default.createElement("col", { style: { width: "80%" } })),
                        react_1.default.createElement("thead", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("th", null, "\u7F16\u53F7"),
                                react_1.default.createElement("th", null, "\u68C0\u6D4B\u9879\u76EE"))),
                        react_1.default.createElement("tbody", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("input", { type: "text", name: "product_id", value: productProps.product_id })),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("input", { type: "text", name: "productname", value: productProps.productname })))))),
                react_1.default.createElement("div", { className: "table-container" },
                    react_1.default.createElement("table", null,
                        react_1.default.createElement("colgroup", null,
                            react_1.default.createElement("col", { style: { width: "20%" } }),
                            react_1.default.createElement("col", { style: { width: "80%" } })),
                        react_1.default.createElement("tbody", null, products.map(function (item) { return (react_1.default.createElement("tr", { key: item.product_id },
                            react_1.default.createElement("td", null, item.product_id),
                            react_1.default.createElement("td", null, item.productname))); })))))),
        products.length > 5 && react_1.default.createElement(DivNote, null)));
}
